import React, { useState } from "react";
import { ReactComponent as LogoSVG } from "../../assets/images/logo.svg";
import { ReactComponent as SearchIcon } from "../../assets/icons/searchIcon.svg";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  HEADER_CREATE_BUTTON,
  HEADER_LOGIN_BUTTON,
} from "../../constants/constants";
import UserProfileDropdown from "./UserProfileHeader";
import { clearUserInfo, hideIdleModal, hideLoginModal, logout } from "../../store/auth/authSlice";
import useScreenSize from "../../Hooks/useScreenSize";
import { setClearClaimDetails } from "../../store/claim/claimSlice";
import { Button } from "../common";
import DemoModal from "../common/DemoModal";
import { handlePromptStripePayment } from "../../utils/Helper";
import { useLogOutUserMutation } from "../../store/auth/usersApiSlice";

const Header = ({ liftHeader = false, prompt = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const isPrompt = location.pathname.includes("prompt");
  const { isMobile, isTablet, isDesktop } = useScreenSize();
  const [showBanner, setshowBanner] = useState(true);
  const [showDemoModal, setShowDemoModal] = useState(false)
  const { userInfo, token } = useSelector((state) => state.auth);
  const [logOutUser] = useLogOutUserMutation();
  const { REACT_APP_GPT_PROMPT_PAYMENT_LINK } = process.env;

  const toggleDrawer = () => {
    setIsOpen(!isOpen);
  };

  const handleClose = () => {
    setshowBanner(false)
  }

  const handleLogout = async (e) => {
    e.preventDefault();
    await logOutUser({ token })
    // const res = await fetch(`${process.env.REACT_APP_K_HUB_URL}/api/auth/logout`, {
    //   method: "POST",
    //   credentials: "include", // 👈 VERY important
    // });

    // const data = await res.json();
    dispatch(hideIdleModal());
    dispatch(logout());
    dispatch(hideLoginModal());
    dispatch(setClearClaimDetails())
    dispatch(clearUserInfo());
    navigate(isPrompt ? "login/prompt" : "/login");
  };

  return (
    <>
      <header className={`${liftHeader ? "absolute top-0 left-0 bg-transparent w-full z-[1]" : ""}`}>
        <nav className={`${(isPrompt || prompt) ? "bg-transparent z-[9999999999999]" : "bg-white"} border-gray-200 px-4 lg:px-6 py-4 shadow-lg`}>
          <DemoModal
            showDemoModal={showDemoModal}
            setShowDemoModal={setShowDemoModal}
          />
          <div className="flex flex-wrap justify-between items-center mx-auto max-w-7xl ">
            <Link to={isPrompt ? "gpt-prompts/access" : "/"} className="flex items-center">
              <LogoSVG />
            </Link>
            <div className="flex items-center lg:order-2">
              {!isPrompt && <button
                className="sm:block hidden"
                onClick={() => {
                  navigate("/search");
                }}
              >
                <SearchIcon />
              </button>}
              {!userInfo && (
                <>
                  <Link
                    to={isPrompt ? "login/prompt" : "/login"}
                    className="text-primary font-medium rounded-lg text-sm px-4 lg:px-5 py-2 lg:py-2.5 mr-2  focus:outline-none hidden md:block"
                  >
                    {HEADER_LOGIN_BUTTON}
                  </Link>
                  {!isPrompt && <Button onClick={() => setShowDemoModal(true)} classes={"text-white bg-button hover:bg-primary-800 font-medium rounded text-sm px-6 lg:px-6 py-2 lg:py-2.5 mr-2 hidden md:block"}>Schedule Demo</Button>}

                </>
              )}
              {
                (!userInfo?.has_gpt && isPrompt) && <Button onClick={() => handlePromptStripePayment(REACT_APP_GPT_PROMPT_PAYMENT_LINK)} classes=" hidden sm:block w-[131px] h-[48px] bg-white text-[#002940] rounded-[8px] font-semibold flex justify-center items-center border border-[#002940]">Get Started</Button>

              }
              {userInfo && <UserProfileDropdown />}
              <button
                onClick={toggleDrawer}
                data-collapse-toggle="navbar-default"
                type="button"
                className="inline-flex items-center p-2 ml-3 text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 "
                aria-controls="navbar-default"
                aria-expanded="false"
              >
                <span className="sr-only">Open main menu</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                >
                  <path
                    d="M4 9H16"
                    stroke="#6E6E6E"
                    strokeWidth="1.5"
                    strokeLinecap="square"
                  />
                  <path
                    d="M4 16H28"
                    stroke="#6E6E6E"
                    strokeWidth="1.5"
                    strokeLinecap="square"
                  />
                  <path
                    d="M16 23L28 23"
                    stroke="#6E6E6E"
                    strokeWidth="1.5"
                    strokeLinecap="square"
                  />
                </svg>
              </button>
            </div>
          </div>
          <div
            id="drawer-example"
            className={`fixed top-0 left-0 z-40 h-screen max-h-screen p-4 overflow-y-auto transition-transform ${isOpen ? "transform-none" : "-translate-x-full"
              } bg-white w-80 `}
            tabIndex="-1"
            aria-labelledby="drawer-label"
          >
            <button
              type="button"
              onClick={toggleDrawer}
              data-drawer-hide="drawer-example"
              aria-controls="drawer-example"
              className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 absolute top-2.5 right-2.5 inline-flex items-center "
            >
              <svg
                aria-hidden="true"
                className="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                ></path>
              </svg>
              <span className="sr-only">Close menu</span>
            </button>
            <div className="flex flex-col pt-5 text-left">
              {userInfo ? <Link
                to="#"
                onClick={handleLogout}
                className="text-primary hover:bg-gray-50 focus:ring-4 font-medium rounded-lg text-sm px-4 lg:px-5 py-2 lg:py-2.5 mr-2 focus:outline-none "
              >
                Log out
              </Link> : <Link
                to={`/login/${prompt ? "prompt" : "home"}`}
                className="text-primary hover:bg-gray-50 focus:ring-4 font-medium rounded-lg text-sm px-4 lg:px-5 py-2 lg:py-2.5 mr-2 focus:outline-none "
              >
                Log In
              </Link>}
              {userInfo && <Link
                to="/dashboard"
                className="text-primary hover:bg-gray-50 focus:ring-4 font-medium rounded-lg text-sm px-4 lg:px-5 py-2 lg:py-2.5 mr-2 focus:outline-none "
              >
                Dashboard
              </Link>}
              {!isPrompt ? <Link
                to="/sign-up"
                className={`text-white bg-primary hover:bg-primary-800 font-medium rounded-full text-sm px-6 lg:px-6 py-2 lg:py-2.5 mr-2 focus:outline-none`}
              >
                {isPrompt ? "Get Started" : HEADER_CREATE_BUTTON}
              </Link> :
                <Button onClick={() => handlePromptStripePayment(REACT_APP_GPT_PROMPT_PAYMENT_LINK)} classes="w-[131px] h-[48px] bg-white text-[#002940] rounded-[8px] font-semibold flex justify-center items-center border border-[#002940]">Get Started</Button>}
            </div>
          </div>
        </nav>
      </header>
      {!isPrompt && isMobile && showBanner && <div className="relative bg-disable p-1 text-center">
        <button onClick={handleClose} className="absolute top-[-8px] right-[-4px] p-2 focus:outline-none">
          <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" d="M14.293 5.293a1 1 0 010 1.414L11.414 10l2.879 2.293a1 1 0 11-1.414 1.414L10 11.414l-2.293 2.879a1 1 0 01-1.414-1.414L8.586 10 5.707 7.707a1 1 0 111.414-1.414L10 8.586l2.293-2.879a1 1 0 011.414 0z" clipRule="evenodd" />
          </svg>
        </button>
        <p className="text-f10 font-bold text-white">
          Some features disabled on mobile. Please use desktop for best experience.
        </p>
      </div>}
    </>
  );
}

export default Header;
